import { createBrowserHistory } from 'history';
import React, { Component } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { commonConstant, SwipeToDelete } from '../../../common';
import { getEntriesFromCart } from '../../../services/promotion/bundle.service';
import { getCustomerFOA } from '../../../services/promotion/foa.service';
import {
  addPremiumItemToCart,
  addProductsToCart,
  deleteCartItems,
  deleteCartItemsPublic,
  deleteCouponToCart,
  displayStockLevelStatus,
  getCart,
  getCartInstallment,
  getCartPublic,
  getPriceFormat,
  getPriceWithoutCurrency,
  getPromotionList,
  INSTALLMENT_TYPE,
  isCartABOMemberType,
  isCartABOType,
  isCartMemberType,
  message,
  PAYMENT_OPTION,
  RULE_BASED,
  SOP_BASIC,
  SOP_BEYOND,
  updateCart,
  updateCartPublic,
  getCartId,
  STOCK_STATUS
} from '../../../services/promotion/utils.service';
import Liff from '../../modal/Liff';
import LiffPromotionList from '../../modal/LiffPromotionList';
import '../../promotion/CartPromotion.scss';
import { SOPProfileList } from '../../sop/SOPProfileList/index';
import CouponPanel from '../CouponPanel';
import InputCoupon from '../InputCoupon';
import BundleProductItem from '../PromotionTemplate/BundleProductItem';
import Product, { ProductItemType } from '../PromotionTemplate/Product';
import PromotionItem from '../PromotionTemplate/PromotionItem';
import {
  ABO_MEMBER,
  FOA_MEMBER,
  UpdateState,
} from '../SelectProduct/PromotionProduct';
import { liffGetProfile } from '../../../services/promotion/auth.service';
import { getCartData } from '../../../actions/cartAction';
import { connect } from 'react-redux';
import { Checkbox } from '../../../helpers';
import { DELETE_PRODUCT_ERROR_MSG, ROUTE_TO_PRODUCT_PAGE, SESSION_KEY } from '../../../common/commonConstant';
import CustomSweetAlert from '../../../common/customSweetAlert/CustomSweetAlert';
import { CART_UPDATE } from '../../../actions/types';

export const history = createBrowserHistory();

const { liff } = window;

export class CartPromotion extends Component {
  cartProductkitEntries = [];
  urlParams = new URLSearchParams(this.props.location.search);

  constructor(props) {
    super(props);
    this.state = {
      cart: null,
      pifCart: this.urlParams.get(SESSION_KEY.isInstallment) === INSTALLMENT_TYPE.FALSE && props.location.state?.pifCart?.length && props.location.state?.pifCart[0] ? props.location.state?.pifCart : null,
      zippCart: this.urlParams.get(SESSION_KEY.isInstallment) === INSTALLMENT_TYPE.TRUE && props.location.state?.pifCart?.length && props.location.state?.pifCart[0] ? props.location.state?.pifCart : null,
      loading: true,
      isLiffopen: false,
      isLiffPromotionOpen: false,
      productEntries: [],
      pifProductEntries: [],
      zippProductEntries: [],
      isInstallment: this.urlParams.get(SESSION_KEY.isInstallment) === INSTALLMENT_TYPE.TRUE && sessionStorage.getItem(SESSION_KEY.zippCartId) ? true : false,
      phone: '',
      customerData: null,
      haveAddress: false,
      selectedPaymentTab: this.urlParams.get(SESSION_KEY.isInstallment) === INSTALLMENT_TYPE.TRUE ? PAYMENT_OPTION.ZIPP : PAYMENT_OPTION.PIF,
      lastSelectedPaymentTab: null,
      promotionList: [],
      isSopLiffOpen: false,
      customerFOA: false,
      isInitialLoad: true,
      selected: [],
      isSelectAll: false,
      openPremiumItemId: null,
      cartTypeName: this.urlParams.get(SESSION_KEY.isInstallment) === INSTALLMENT_TYPE.TRUE ? 'zippCart' : 'pifCart'
    };

    this.onOpenLiff = this.onOpenLiff.bind(this);
    this.onCloseLiff = this.onCloseLiff.bind(this);
    this.onCloseSopLiff = this.onCloseSopLiff.bind(this);
    this.onUpdateCart = this.onUpdateCart.bind(this);
    this.goToAllProductPage = this.goToAllProductPage.bind(this);
    this.goToAddressList = this.goToAddressList.bind(this);
    this.handleIntitCart = this.handleIntitCart.bind(this);
    this.setProductSelected = this.setProductSelected.bind(this);
    this.handlePremiumItemSet = this.handlePremiumItemSet.bind(this);
    this.onOpenPromotionLiff = this.onOpenPromotionLiff.bind(this);
    this.onClosePromotionLiff = this.onClosePromotionLiff.bind(this);
    this.onOpenOptionsLiff = this.onOpenOptionsLiff.bind(this);
    this.onCloseOptionsLiff = this.onCloseOptionsLiff.bind(this);
    this.fetchCartData = this.fetchCartData.bind(this);
    this.fetchPIFCart = this.fetchPIFCart.bind(this);
    this.fetchZIPPCart = this.fetchZIPPCart.bind(this);
    this.fetchPromotionList = this.fetchPromotionList.bind(this);
    this.renderPromotionList = this.renderPromotionList.bind(this);
    this.navigatePromotion = this.navigatePromotion.bind(this);
    this.onPromoClose = this.onPromoClose.bind(this);
    this.isProductPromotion = this.isProductPromotion.bind(this);
    this.handleCheckBoxClick = this.handleCheckBoxClick.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.renderProduct = this.renderProduct.bind(this);
    this.getPromotions = this.getPromotions.bind(this);
    this.setUrlParam = this.setUrlParam.bind(this);
  }

  async componentDidMount() {
    this.setUrlParam();
    if (this.props?.data) {
      await this.props.getCartData('FULL', getCartId(this.urlParams.get(SESSION_KEY.isInstallment)));
      if (this.props.data?.[0]) {
        if (this.props.data?.[0].paymentType === PAYMENT_OPTION.PIF) {
          sessionStorage.setItem(SESSION_KEY.pifCartId, this.props.data?.[0].id);
        } else {
          sessionStorage.setItem(SESSION_KEY.zippCartId, this.props.data?.[0].id);
        }
      }
    }
    this.handleIntitCart();
    const customer = JSON.parse(sessionStorage.getItem('customer'));
    const hasCustomerFOA =
      customer.type === 'public' || customer.type === 'foa';
    this.setState({ customerFOA: hasCustomerFOA, [this.state.cartTypeName]: this.props?.data });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data && !this.state.isInitialLoad) {
      this.setState({ [this.state.cartTypeName]: this.props?.data })
      await this.fetchCartData();
      await this.handlePremiumItemSet();
    }
    if (prevState.selectedPaymentTab !== this.state.selectedPaymentTab) {
      if (this.urlParams.has(SESSION_KEY.isInstallment)) {
        if (this.state.selectedPaymentTab === PAYMENT_OPTION.PIF) {
          this.urlParams.set(SESSION_KEY.isInstallment, INSTALLMENT_TYPE.FALSE);
        } else {
          this.urlParams.set(SESSION_KEY.isInstallment, INSTALLMENT_TYPE.TRUE);
        }
      }
      this.handleIntitCart(true);
      this.props.history.replace({ search: this.urlParams.toString() });
    }
  }

  setUrlParam = () => {
    if (!sessionStorage.getItem(SESSION_KEY.zippCartId)) {
      this.urlParams.set(SESSION_KEY.isInstallment, INSTALLMENT_TYPE.FALSE);
    } else if (!sessionStorage.getItem(SESSION_KEY.pifCartId)) {
      this.urlParams.set(SESSION_KEY.isInstallment, INSTALLMENT_TYPE.TRUE);
    }
    this.props.history.replace({ search: this.urlParams.toString() });
  }

  async handleIntitCart(flag = false) {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    await this.fetchCartData(flag);
    await this.handlePremiumItemSet();
    if (cart) {
      for (const entry of cart?.entries) {
        if (entry.kitEntryCode) {
          this.setProductSelected(
            entry.product.id,
            entry.quantity,
            UpdateState.INIT,
            entry.kitEntryCode,
            entry.id,
          );
        }
      }
    }
  }

  async fetchPromotionList() {
    try {
      this.setState({ loading: true });
      const customerFOA = JSON.parse(sessionStorage.getItem('customerFOAData'));
      const guid = sessionStorage.getItem('guid');
      const { userId } = await liffGetProfile();
      const id = customerFOA ? guid : userId;
      const promotionList = await getPromotionList(id);
      this.setState({
        promotionList,
        loading: false,
      });
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
      CustomSweetAlert({
        title: "",
        text: message.error.somethingWrong,
        confirmButtonText: "ตกลง",
      });
    }
  }

  async fetchCartData(flag = false) {
    try {
      await this.fetchZIPPCart(flag);
      await this.fetchPIFCart(flag);
      this.updateSelectedPaymentTab(
        this.state.lastSelectedPaymentTab
          ? this.state.lastSelectedPaymentTab
          : this.state.isInstallment
            ? PAYMENT_OPTION.ZIPP
            : PAYMENT_OPTION.PIF,
      );
    } catch (error) {
      console.log(error);
      CustomSweetAlert({
        title: "",
        text: message.error.somethingWrong,
        confirmButtonText: "ตกลง",
      });
    }
  }

  async fetchPIFCart(flag = false) {
    try {
      if (!this.state.isInstallment && sessionStorage.getItem(SESSION_KEY.pifCartId) || !sessionStorage.getItem(SESSION_KEY.zippCartId)) {
        this.setState({ loading: true });
        const customerFOA = JSON.parse(sessionStorage.getItem('customerFOAData'));
        if (!localStorage.getItem('deleteIds')) {
          localStorage.setItem('deleteIds', '[]');
        }
        const guid = sessionStorage.getItem('guid');
        let pifCart = this.state.pifCart;
        if ((!pifCart || flag) && (!this.state.isInstallment || sessionStorage.getItem(SESSION_KEY.pifCartId))) {
          const cartId = sessionStorage.getItem(SESSION_KEY.pifCartId);
          pifCart = !customerFOA
            ? await this.props.getCartData("FULL", cartId)
            : await getCartPublic(guid);
        }
        if ((this.state.isInstallment && (pifCart && pifCart.length && pifCart[0]?.paymentType !== PAYMENT_OPTION.PIF)) || !pifCart?.[0]) {
          this.setState({
            loading: false
          });
          return;
        }
        this.props.updateCart(pifCart);
        const localAddress =
          sessionStorage.getItem('address') !== null
            ? JSON.parse(sessionStorage.getItem('address'))
            : null;
        if (customerFOA) {
          this.setState({
            customerData: {
              ...customerFOA,
              address: localAddress,
            },
            phone: localAddress?.phone ? localAddress.phone : '',
          });
        }
        const pifCartData = pifCart && pifCart.length ? pifCart[0] : {};
        const pifCartId = pifCartData && pifCartData.id ? pifCartData.id : null;
        let pifProductEntries = getEntriesFromCart(pifCartData);
        pifProductEntries = this.setQuantityToProduct(pifProductEntries);
        this.setState({
          pifCart,
          loading: false,
          pifProductEntries,
        });
        if (!localStorage.getItem('pifCartId')) {
          localStorage.setItem('pifCartId', JSON.stringify(pifCartId));
        }
        // check cartId in localStorage
        const cartLocal = JSON.parse(localStorage.getItem('pifCartId'));
        if (cartLocal !== pifCartId) {
          localStorage.setItem('pifCartId', JSON.stringify(pifCartId));
          localStorage.setItem('deleteIds', '[]');
        }
        // check address member-abo
        if (!this.state.customerData) {
          if (
            pifCartData &&
            pifCartData?.deliveryMethod.address?.fullAddress !== ''
          ) {
            this.setState({ haveAddress: true, pifCart: pifCart });
          } else {
            this.setState({ haveAddress: false });
          }
        } else {
          //check address public
          const address = sessionStorage.getItem('address');
          if (address) {
            this.setState({ haveAddress: true, pifCart: pifCart });
          } else {
            this.setState({ haveAddress: false });
          }
        }
        this.setState({ loading: false });
      }
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
      CustomSweetAlert({
        title: "",
        text: message.error.somethingWrong,
        confirmButtonText: "ตกลง",
      });
    }
  }

  async fetchZIPPCart(flag = false) {
    try {
      if (!localStorage.getItem('deleteIds')) {
        localStorage.setItem('deleteIds', '[]');
      }
      const cartId = sessionStorage.getItem(SESSION_KEY.zippCartId);
      if (this.state.isInstallment && !cartId) {
        // CustomSweetAlert({
        //   title: "",
        //   text: 'ไม่พบข้อมูลตะกร้าสินค้า',
        //   confirmButtonText: "ตกลง",
        // });
        return;
      }
      if (this.state.isInstallment && sessionStorage.getItem(SESSION_KEY.zippCartId)) {
        this.setState({ loading: true });
        let zippCart = (this.state.zippCart?.length && this.state.zippCart[0])
          ? this.state.zippCart[0] : this.state.zippCart ? this.state.zippCart : null;
        zippCart = zippCart?.length ? zippCart?.[0] : zippCart;
        if ((!zippCart || flag) && this.state.isInstallment && cartId) {
          zippCart = await this.props.getCartData("FULL", cartId);
          zippCart = zippCart.length ? zippCart[0] : zippCart;
        }
        if ((!this.state.isInstallment && zippCart && (zippCart?.paymentType !== PAYMENT_OPTION.ZIPP || zippCart[0]?.paymentType === PAYMENT_OPTION.ZIPP_ABO)) || !zippCart) {
          this.setState({
            loading: false
          });
          return;
        }

        let zippProductEntries = getEntriesFromCart(zippCart);
        zippProductEntries = this.setQuantityToProduct(zippProductEntries);
        this.setState({
          zippCart: [zippCart],
          loading: false,
          zippProductEntries,
        });

        if (zippCart && zippCart?.deliveryMethod.address?.fullAddress !== '') {
          this.setState({ haveAddress: true });
        } else {
          const address = sessionStorage.getItem('address');
          if (address) {
            this.setState({ haveAddress: true });
          } else {
            this.setState({ haveAddress: false });
          }
        }
        console.log('ZIPP cart : ', zippCart);
        return;
      }
      this.setState({ loading: false });
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
      CustomSweetAlert({
        title: "",
        text: message.error.somethingWrong,
        confirmButtonText: "ตกลง",
      });
    }
  }

  async handlePremiumItemSet() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    if (cart) {
      if (cart?.premiumItemSet.length !== 0) {
        this.setState({ loading: true });
        const productIds = [];
        const partnerPromotionId = [];
        const deleteLocal = JSON.parse(localStorage.getItem('deleteIds'));
        for (const entry of cart?.entries || []) {
          productIds.push(entry.product.id);
          if (entry.partnerPromotionId) {
            partnerPromotionId.push(entry.partnerPromotionId);
          }

        }
        for (const premiumItem of cart?.premiumItemSet || []) {
          const premiumItemSet = premiumItem;
          const firstItem = premiumItemSet?.premiumItems[0];
          let isHavePremiumSetTocart = false;
          for (const item of premiumItemSet?.premiumItems) {
            if (productIds.includes(item.id) && partnerPromotionId.includes(item.partnerPromotionId)) {
              const productIndex = productIds.findIndex((v) => v === item.id);
              const selectedEntry = cart?.entries.find(entry => entry.product.id === productIds[productIndex]);
              if (selectedEntry && selectedEntry.quantity !== (selectedEntry.latestQuantity + premiumItemSet.elligibleTargetQty)) {
                const quantity = selectedEntry.quantity;
                isHavePremiumSetTocart = true;
                if (getPriceWithoutCurrency(item.targetPrice) === 0) {
                  const data = await updateCart(
                    cart?.id,
                    selectedEntry.id,
                    quantity + premiumItemSet.elligibleTargetQty,
                    premiumItemSet.code
                  );
                  const newDeleteLocal = deleteLocal.filter(
                    (v) => v.product.id !== item.id,
                  );
                  localStorage.setItem(
                    'deleteIds',
                    JSON.stringify(newDeleteLocal),
                  );
                  if (data && data?.entries) {
                    this.setState({ cart: [data], [this.state.cartTypeName]: [data] });
                    await this.fetchCartData();
                  } else {
                    await this.fetchCartData(true);
                  }
                }
              }
            }
          }
          if (!isHavePremiumSetTocart) {
            const hasDelete = deleteLocal.find(
              (v) => v.product.id === firstItem.id,
            );
            if (!hasDelete && premiumItemSet.elligibleTargetQty) {
              this.setState({ loading: true });
              const data = await addPremiumItemToCart(
                cart.id,
                firstItem,
                premiumItemSet.elligibleTargetQty,
                premiumItemSet.code
              );
              const newDeleteLocal = deleteLocal.filter(
                (v) => v.product.id !== firstItem.id,
              );
              if (data && data?.entries) {
                this.setState({ cart: [data], [this.state.cartTypeName]: [data] });
                await this.fetchCartData();
              } else {
                await this.fetchCartData(true);
              }
              localStorage.setItem('deleteIds', JSON.stringify(newDeleteLocal));
            }
          }
        }
        this.setState({ loading: false });
      }
    } else {
      localStorage.setItem('deleteIds', '[]');
    }
  }

  async onUpdateCart(cartId, itemId, quantity) {
    try {
      this.setState({ loading: true });
      const guid = sessionStorage.getItem('guid');
      let cart;
      !this.state.customerData
        ? cart = await updateCart(cartId, itemId, quantity)
        : cart = await updateCartPublic(cartId, itemId, quantity, guid);
      this.setState({ [this.state.cartTypeName]: [cart], productEntries: cart.entries, loading: false });
      this.props.updateCart([cart]);
      await this.fetchCartData();
      await this.handlePremiumItemSet();
    } catch (error) {
      console.log(error);
      CustomSweetAlert({
        title: "",
        text: message.error.somethingWrong,
        confirmButtonText: "ตกลง",
      });
    }
  }

  async getPromotions() {
    if (!this.state.promotionList.length) {
      await this.fetchPromotionList();
    }
    this.onOpenLiff();
  }

  onOpenLiff() {
    this.setState({ isLiffopen: true });
  }

  onCloseLiff() {
    this.setState({ isLiffopen: false });
    this.fetchCartData(true);
  }

  onOpenPromotionLiff() {
    this.setState({ isLiffPromotionOpen: true });
  }

  onClosePromotionLiff() {
    this.setState({ isLiffPromotionOpen: false });
  }
  onOpenOptionsLiff(premiumItemCode) {
    this.setState({ openPremiumItemId: premiumItemCode });
  }

  onCloseOptionsLiff() {
    this.setState({ openPremiumItemId: null });
  }

  navigatePromotion(promotion) {
    if (promotion && promotion.id) {
      const redirectUrl = `${commonConstant.pathProductPromotion}?id=${promotion.id}&productId=`;
      window.location.href = redirectUrl;
    }
  }

  onSopBtnClick() {
    this.setState({ isSopLiffOpen: true });
  }

  onCloseSopLiff() {
    this.setState({ isSopLiffOpen: false });
  }

  onPromotionBtnClick() {
    this.onOpenPromotionLiff();
  }

  setQuantityToProduct(entries) {
    const newRelatedProducts = entries.map((entry) => {
      entry.product.quantity = entry.quantity;
      if (entry.product.kitEntries.length > 0) {
        entry.product.kitEntries.map((kitEntry) => {
          const configuredQty = kitEntry.configuredQty;
          if (kitEntry.product.baseOptions.length > 0) {
            const baseOptions = kitEntry.product.baseOptions[0];
            let qtyFlag = false;
            if (baseOptions.options.find(el => el.quantity)) {
              qtyFlag = true;
            }
            baseOptions.options.map(option => {
              if (kitEntry.product.baseProduct) {
                if (baseOptions.selectedId) {
                  const qty = baseOptions.selectedId === option.id ? configuredQty : 0;
                  option.quantity = qty;
                  option.lastQuantity = qty;
                }
              } else {
                let qty = 0;
                if (!qtyFlag && option.stock?.stockLevelStatus !== STOCK_STATUS.outOfStock && !option.quantity) {
                  qty = configuredQty;
                  qtyFlag = true;
                } else {
                  if (option.quantity || option.quantity === 0) {
                    qty = option.quantity;
                    qtyFlag = true;
                  }
                }
                option.quantity = qty;
                option.lastQuantity = qty;
              }
            });
          }
        });
      }
      return entry;
    });
    return newRelatedProducts;
  }

  async setProductSelected(productId, quantity, updateState, kitEntryCode, entryId) {
    const productEntries = this.state.productEntries.map((entry) => {
      if (entry.product.id === productId) {
        entry.product.quantity = quantity;
      }
      if (entry.product.kitEntries.length > 0 && kitEntryCode?.includes(entry?.alias)) {
        entry.entriesId = [...entry.entriesId?.includes(entry.id) ? entry.entriesId : [entry.id], ...entry.entriesId?.includes(entryId) ? [] : [entryId]];

        entry.product.kitEntries.map((kitEntry) => {
          if (kitEntryCode.indexOf(entry.alias) >= 0) {
            kitEntry.kitEntryCodeAlias = kitEntryCode;
            if (kitEntry.product.baseOptions.length > 0) {
              const baseOptions = kitEntry.product.baseOptions[0];
              baseOptions.options.map((option) => {
                if (updateState === UpdateState.FINISH) {
                  option.lastQuantity = option.quantity;
                } else if (option.id === productId) {
                  if (updateState === UpdateState.CHANGE) {
                    option.quantity = quantity;
                  }
                  if (updateState === UpdateState.INIT) {
                    option.quantity = quantity;
                    option.lastQuantity = quantity;
                  }
                  if (updateState === UpdateState.CLEAR) {
                    option.quantity = option.lastQuantity;
                  }
                }
              });
            }
          }
        });
      }
      return entry;
    });
    this.setState({ productEntries });

    if (updateState === UpdateState.FINISH) {
      const productEntry = productEntries.find(
        (value) => value.alias === kitEntryCode,
      );

      const cart = this.state.isInstallment
        ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
        : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
      try {
        this.setState({ loading: true });
        const addProductResponse = await addProductsToCart(cart.id, [
          productEntry.product,
        ]);

        if (addProductResponse.error) {
          CustomSweetAlert({
            title: "",
            text: addProductResponse.error[0].th_message,
            confirmButtonText: "ตกลง",
          });
          this.setState({ loading: false });
          return;
        }

        const isInstallment = this.urlParams.get(SESSION_KEY.isInstallment) === INSTALLMENT_TYPE.TRUE;

        const guid = sessionStorage.getItem('guid');

        !this.state.customerData
          ? await deleteCartItems(cart.id, [productEntry.id], isInstallment)
          : await deleteCartItemsPublic(
            cart.id,
            [productEntry.id],
            isInstallment,
            guid,
          );

        this.setState({
          productEntries: [],
          loading: false
        });
        await this.handleIntitCart();

        return;
      } catch (error) {
        console.log(error);
        CustomSweetAlert({
          title: "",
          text: message.error.somethingWrong,
          confirmButtonText: "ตกลง",
        });
        window.location.reload();
        return;
      }
    }
  }

  renderProduct() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    if (!cart) {
      return null;
    }

    return this.state.productEntries.map((entry, index) => {
      if (entry.kitEntryCode || entry.isGiveAway) {
        return null;
      }

      const {
        totalPrice,
        quantity,
        amwayValue,
        kitProductTotalPriceInclTax,
        qualifiedSubscriptions,
      } = entry;

      const {
        id,
        sku,
        stock,
        prices,
        kitEntries,
        identifier,
        galleryImages,
        type,
      } = entry.product;

      const img = galleryImages.length > 0 ? galleryImages[0].image_url : '';
      const isBundletItem = kitEntries.length > 0;
      let customerFOA = sessionStorage.getItem('customerFOAData');
      let aboPrice = prices.find((value) => value.type === ABO_MEMBER);
      let foaPrice = prices.find((value) => value.type === FOA_MEMBER);
      aboPrice = aboPrice?.price ? parseInt(aboPrice.price) : 0;
      foaPrice = foaPrice?.price ? parseInt(foaPrice.price) : 0;
      const isSOPProduct = entry.hasSopEntries;
      const isRuleBased =
        isSOPProduct && type && type.toLowerCase() === RULE_BASED.toLowerCase();
      const parentQualification =
        qualifiedSubscriptions && qualifiedSubscriptions.length
          ? qualifiedSubscriptions[0]
          : null;
      let isSOPBeyondEntry = false;
      let isSOPBasicEntry = false;
      let sopTagMsg = '';
      let tagClr = '';
      let sopChildEntries = [];
      let totalSopChildQty = 0;

      if (
        isRuleBased &&
        kitProductTotalPriceInclTax &&
        kitProductTotalPriceInclTax.price &&
        parseInt(kitProductTotalPriceInclTax.price) > 0
      ) {
        aboPrice = kitProductTotalPriceInclTax.price;
        foaPrice = kitProductTotalPriceInclTax.price;
      }

      if (isRuleBased && identifier) {
        isSOPBeyondEntry = identifier
          .toLowerCase()
          .includes(SOP_BEYOND.toLowerCase());
        isSOPBasicEntry = identifier
          .toLowerCase()
          .includes(SOP_BASIC.toLowerCase());

        sopTagMsg = isSOPBeyondEntry
          ? 'SOP บียอนด์'
          : isSOPBasicEntry
            ? 'SOP เบสิค'
            : '';
        tagClr = isSOPBeyondEntry
          ? 'beyond-clr'
          : isSOPBasicEntry
            ? 'basic-clr'
            : '';
      } else if (entry.hasSopEntries) {
        sopTagMsg = 'SOP Flex';
        tagClr = 'flex-clr';
      }

      if (
        isRuleBased &&
        (isSOPBeyondEntry || isSOPBasicEntry) &&
        parentQualification
      ) {
        sopChildEntries = this.getSopChildEntries(parentQualification);
        totalSopChildQty = sopChildEntries.reduce((sum, entry) => {
          return sum + entry.quantity;
        }, 0);
      }

      const { accountType = '' } = cart && cart?.account ? cart?.account : {};
      const isABOType = isCartABOType(accountType);
      const isABOMemberType = isCartABOMemberType(accountType);

      const ids = Array.isArray(entry.entriesId) ? entry.entriesId : [entry.id];

      if (isBundletItem) {
        const props = {
          id: id,
          idList: ids,
          img: img,
          index,
          code: sku,
          alias: entry.alias,
          amwayValue: isABOType ? amwayValue : null,
          stock: stock,
          total: quantity,
          title: identifier,
          hasSopEntries: isSOPProduct,
          kitEntries: kitEntries,
          quantity: entry.quantity,
          price: isABOMemberType ? aboPrice : foaPrice,
          totalPrice: parseInt(totalPrice.price),
          productItemType: ProductItemType.CART,
          setProductSelected: this.setProductSelected,
          selected: this.state.selected,
          showCheckBox: true,
          handleCheckBoxClick: this.handleCheckBoxClick,
          renderSvgForCheckbox: this.renderSvgForCheckbox,
          onDelete: this.onDelete
        };
        return <BundleProductItem key={entry.alias} {...props} />;
      }

      const props = {
        img: img,
        code: sku,
        amwayValue: isABOType ? amwayValue : null,
        id: entry.id,
        stock: stock,
        price: isABOMemberType ? aboPrice : foaPrice,
        cartId: cart.id,
        title: identifier,
        hasSopEntries: isSOPProduct,
        total: entry.quantity,
        callback: this.onUpdateCart,
        productItemType: ProductItemType.CART,
        totalPrice: parseInt(totalPrice.price),
        sopTagMsg: sopTagMsg,
        tagClr: tagClr,
        sopChildEntries: sopChildEntries,
        totalSopChildQty: totalSopChildQty,
        selected: this.state.selected,
        showCheckBox: true,
        handleCheckBoxClick: this.handleCheckBoxClick,
        renderSvgForCheckbox: this.renderSvgForCheckbox
      };
      return (
        <div className="card-product-container mb-10" key={index}>
          <SwipeToDelete id={entry.id} onDelete={this.onDelete}>
            <Product key={img} {...props} />
          </SwipeToDelete>
        </div >
      );
    });
  }

  getSopChildEntries(qualifiedSubscriptions) {
    const childEntries = [];
    const entries = [];
    const { cycleSequence, elementSequence, subscriptionIdentifier } =
      qualifiedSubscriptions;
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    if (!cart) {
      return entries;
    }
    cart.entries.forEach((entry, index) => {
      if (
        entry.hasSopEntries &&
        entry.kitEntryCode &&
        entry.qualifiedSubscriptions &&
        entry.qualifiedSubscriptions.length
      ) {
        const subscription = entry.qualifiedSubscriptions[0];
        const childCycleSequence = subscription.cycleSequence;
        const childElementSequence = subscription.elementSequence;
        const childSubscriptionIdentifier = subscription.subscriptionIdentifier;

        if (
          cycleSequence === childCycleSequence &&
          elementSequence === childElementSequence &&
          subscriptionIdentifier === childSubscriptionIdentifier
        ) {
          childEntries.push(entry);
        }
      }
    });

    if (childEntries && childEntries.length) {
      childEntries.forEach((entry, index) => {
        const { galleryImages, identifier } = entry.product;
        const img = galleryImages.length > 0 ? galleryImages[0].image_url : '';
        entries.push({ img, identifier, quantity: entry.quantity });
      });
    }

    return entries;
  }

  async onPromoClose() {
    localStorage.setItem('deleteIds', '[]');
    await this.fetchCartData(true);
  }

  isProductPromotion = (value, cart) => {
    const hasPremiumItemSet = cart.premiumItemSet.length > 0;
    if (!hasPremiumItemSet) {
      return false;
    }
    for (const premiumItem of cart.premiumItemSet) {
      const premiumItemSet = premiumItem;
      for (const item of premiumItemSet.premiumItems) {
        const checkPremium = value.product.id === item.id;
        if (checkPremium) {
          return true;
        }
      }
    }
    return false;
  };

  // cart and item level - promotion (pwp,gwp)

  renderGiftProduct() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    if (!cart) {
      return <></>;
    }

    const giftEntries = cart?.entries?.filter((value) => {
      if (
        value.isGiveAway &&
        (parseInt(value?.totalPrice?.price) === 0 || value.partnerPromotionId) &&
        !value?.kitEntryCode &&
        !this.isProductPromotion(value, cart)
      ) {
        return true;
      } else if (
        !value.isGiveAway &&
        (parseInt(value?.totalPrice?.price) === 0 || value.partnerPromotionId) &&
        !value.kitEntryCode &&
        !this.isProductPromotion(value, cart)
      ) {
        return true;
      }
    });

    if (giftEntries?.length === 0) {
      return <></>;
    } else {
      return giftEntries?.map((entry, index) => {
        const { product, quantity } = entry;
        const { identifier, galleryImages, stock } = product;
        const img = galleryImages.length > 0 ? galleryImages[0].image_url : '';

        return (
          <div className="mb-10" key={index}>
            <div className="card-product-body-cart gift-card">
              <div className="gift-product-container">
                <div
                  className="gift-label-div card-product-title-text-cart font-black"
                  style={{ flex: '1 1 0', wordWrap: 'break-word' }}
                >
                  สินค้าแถมฟรี
                </div>
              </div>
              <div className="gift-info-container">
                <img className="gift-img" src={img} alt="gift image" />
                <div className="info-div">
                  <div className="gift-title-container">
                    <div
                      className="cart-product-info-cart font-black"
                      style={{ alignSelf: 'stretch', wordWrap: 'break-word' }}
                    >
                      {identifier}
                    </div>
                    <div className="font-black font-x-small font-stock">
                      {displayStockLevelStatus(stock)}
                    </div>
                  </div>
                  <div
                    className="cart-product-info-cart font-black"
                    style={{ textAlign: 'right', wordWrap: 'break-word' }}
                  >{`x${quantity}`}</div>
                </div>
              </div>
            </div>
          </div>
        );
      });
    }
  }

  renderPromotionProduct() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    if (!cart) {
      return <></>;
    }

    const quantityUpdateCallback = async (
      product,
      option,
      quantity,
      totalPrice,
      targetPrice,
      data
    ) => {
      const tempEntries = cart.entries;
      // if (!quantity) {
      //   this.fetchCartData(true);
      // } else {
      //   this.fetchCartData();
      // }
      if (product) {
        const targetIndex = tempEntries.findIndex((v) => v.id === product.id);
        if (targetIndex !== -1) {
          tempEntries[targetIndex] = { ...tempEntries[targetIndex], quantity, };
        }
      }

      let tempCart = { ...cart };
      if (data?.entries) {
        tempCart = {
          ...tempCart,
          ...data,
          entries: data.entries,
        };
      } else {
        tempCart = {
          ...tempCart,
          entries: tempEntries,
        };
      }

      tempCart.grandTotalPrice = {
        ...tempCart.grandTotalPrice,
        price: totalPrice,
      };
      tempCart.totalPrice = {
        ...tempCart.totalPrice,
        price: totalPrice,
      };

      this.setState({ cart: [tempCart], [this.state.cartTypeName]: [tempCart] });
    };

    const promotionEntries = cart?.entries?.filter((value) => {
      return (
        !value.isGiveAway &&
        parseInt(value.totalPrice.price) > 0 &&
        value.partnerPromotionId &&
        !value.kitEntryCode &&
        this.isProductPromotion(value, cart)
      );
    });
    const promotionItems = [];
    promotionEntries && promotionEntries.map((entry, index) => {
      let premiumItemsOption = null;
      let lastPremiumItemsId = null;
      let elligibleTargetQty = null;
      let hasElligibleTargetQty = null;
      if (cart && cart.premiumItemSet?.length !== 0) {
        for (const premiumItem of cart.premiumItemSet) {
          const premiumItems = premiumItem.premiumItems;
          const selectedPremiumItem = premiumItems.find(
            (value) => value.id === entry.product.id && premiumItem.code === entry.partnerPromotionId
          );
          if (selectedPremiumItem) {
            premiumItemsOption = premiumItems;
            elligibleTargetQty = entry.latestQuantity;
            lastPremiumItemsId = selectedPremiumItem.id;
            hasElligibleTargetQty = premiumItem.elligibleTargetQty;
            const { identifier, galleryImages, id, prices, stock } = entry.product;
            const { grandTotalPrice } = cart;
            const img =
              galleryImages.length > 0 ? galleryImages[0].image_url : '';
            const promotionItem = (
              <PromotionItem
                index={premiumItem}
                img={img}
                cart={cart}
                key={index}
                identifier={identifier}
                premiumItemsOption={premiumItemsOption}
                lastPremiumItemsId={lastPremiumItemsId}
                elligibleTargetQty={elligibleTargetQty}
                hasElligibleTargetQty={hasElligibleTargetQty}
                quantity={entry.quantity}
                totalPrice={parseInt(grandTotalPrice.price)}
                callback={quantityUpdateCallback}
                fetchCart={this.onPromoClose}
                stock={stock}
                isOpenLiff={this.state.openPremiumItemId === premiumItem?.code}
                onOpenLiff={() => this.onOpenOptionsLiff(premiumItem?.code)}
                onCloseLiff={this.onCloseOptionsLiff}
              />
            );
            promotionItems.push(promotionItem);
          }
        }
      }
    });
    // render deleted premiumItem from localStorage
    const deleteLocal = JSON.parse(localStorage.getItem('deleteIds'));
    if (deleteLocal.length !== 0) {
      deleteLocal.map((item, index) => {
        let premiumItemsOption = null;
        let lastPremiumItemsId = null;
        let elligibleTargetQty = null;
        let hasElligibleTargetQty = null;
        if (cart.premiumItemSet.length !== 0) {
          for (const premiumItem of cart.premiumItemSet) {
            const premiumItems = premiumItem.premiumItems;
            const selectedPremiumItem = premiumItems.find(
              (value) => value.id === item.product.id && premiumItem.code === item.partnerPromotionId
            );
            if (selectedPremiumItem) {
              premiumItemsOption = premiumItems;
              lastPremiumItemsId = selectedPremiumItem.id;
              hasElligibleTargetQty = premiumItem.elligibleTargetQty;
              const { identifier, galleryImages, id, prices, stock } = item.product;
              const { grandTotalPrice } = cart;
              const img =
                galleryImages.length > 0 ? galleryImages[0].image_url : '';
              const deletePromotionItem = (
                <PromotionItem
                  index={premiumItem}
                  img={img}
                  cart={cart}
                  key={index}
                  identifier={identifier}
                  premiumItemsOption={premiumItemsOption}
                  lastPremiumItemsId={lastPremiumItemsId}
                  elligibleTargetQty={0}
                  hasElligibleTargetQty={hasElligibleTargetQty}
                  quantity={0}
                  totalPrice={parseInt(grandTotalPrice.price)}
                  prices={prices}
                  callback={quantityUpdateCallback}
                  fetchCart={this.onPromoClose}
                  stock={stock}
                  isOpenLiff={this.state.openPremiumItemId === premiumItem?.code}
                  onOpenLiff={() => this.onOpenOptionsLiff(premiumItem?.code)}
                  onCloseLiff={this.onCloseOptionsLiff}
                />
              );
              const hasPromottionItems = promotionItems.find(
                (v) => v.props.lastPremiumItemsId === lastPremiumItemsId,
              );
              if (!hasPromottionItems) {
                promotionItems.push(deletePromotionItem);
              }
            }
          }
        }
      });
    }

    const giftPromotionEntries = cart?.entries?.filter(
      (value) =>
        // !value.isGiveAway &&
        parseInt(value.totalPrice.price) === 0 &&
        value.partnerPromotionId &&
        !value?.kitEntryCode &&
        this.isProductPromotion(value, cart),
    );

    const giftPromotionItems = [];
    giftPromotionEntries && giftPromotionEntries.map((entry, index) => {
      let premiumItemsOption = null;
      let lastPremiumItemsId = null;
      let elligibleTargetQty = null;
      let hasElligibleTargetQty = null;
      if (cart.premiumItemSet.length !== 0) {
        for (const premiumItem of cart.premiumItemSet) {
          const premiumItems = premiumItem.premiumItems;
          const selectedPremiumItem = premiumItems.find(
            (value) => value.id === entry.product.id && premiumItem.code === entry.partnerPromotionId
          );
          if (selectedPremiumItem) {
            premiumItemsOption = premiumItems;
            elligibleTargetQty = entry.latestQuantity;
            lastPremiumItemsId = selectedPremiumItem.id;
            hasElligibleTargetQty = premiumItem.elligibleTargetQty;
            const { identifier, galleryImages, id, prices, stock } = entry.product;
            const { grandTotalPrice } = cart;
            const img =
              galleryImages.length > 0 ? galleryImages[0].image_url : '';
            const giftPromotionItem = (
              <PromotionItem
                index={premiumItem}
                img={img}
                cart={cart}
                key={index}
                identifier={identifier}
                premiumItemsOption={premiumItemsOption}
                lastPremiumItemsId={lastPremiumItemsId}
                elligibleTargetQty={elligibleTargetQty}
                hasElligibleTargetQty={hasElligibleTargetQty}
                quantity={entry.quantity}
                totalPrice={parseInt(grandTotalPrice.price)}
                callback={quantityUpdateCallback}
                fetchCart={this.onPromoClose}
                stock={stock}
                isOpenLiff={this.state.openPremiumItemId === premiumItem?.code}
                onOpenLiff={() => this.onOpenOptionsLiff(premiumItem?.code)}
                onCloseLiff={this.onCloseOptionsLiff}
              />
            );
            giftPromotionItems.push(giftPromotionItem);
          }
        }
      }
    });

    if (promotionItems.length === 0 && giftPromotionItems.length === 0) {
      return;
    }
    return (
      <>
        {promotionItems}
        {giftPromotionItems}
      </>
    );
  }

  displayFooterCoupon() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    if (!cart) {
      return <></>;
    }

    return cart?.appliedCoupon?.map((coupon, index) => {
      return (
        <div key={index} className="applied-coupon-container font-small">
          {!coupon.redemptionCoupon ? (
            <img
              src="/images/promotion/applied-coupon-blue.svg"
              className="w-100"
            />
          ) : (
            <img
              src="/images/promotion/applied-coupon-red.svg"
              className="w-100"
            />
          )}
          {!coupon.redemptionCoupon ? (
            <div className="dark-blue applied-coupon-left">
              {coupon.name ? coupon.name : coupon.code}
            </div>
          ) : (
            <div className="dark-red applied-coupon-left">
              {coupon.name ? coupon.name : coupon.code}
            </div>
          )}
          {!coupon.redemptionCoupon ? (
            <div className="dark-blue applied-coupon-right-new">
              <div className="coupon-value-new">{`- ฿ ${coupon.value}`}</div>
              <div className="coupon-cross">
                <img
                  src="/images/promotion/icon-uncheck-blue.svg"
                  onClick={() => this.onCancelCoupon(coupon.code)}
                />
              </div>
            </div>
          ) : (
            <div className="dark-red applied-coupon-right-new">
              <div className="coupon-value-new">{`- ฿ ${coupon.value}`}</div>
              <div className="coupon-cross">
                <img
                  src="/images/promotion/icon-uncheck-red.svg"
                  onClick={() => this.onCancelCoupon(coupon.code)}
                />
              </div>
            </div>
          )}
        </div>
      );
    });
  }

  async onCancelCoupon(code) {
    try {
      this.setState({ loading: true });
      const cart = this.state.isInstallment
        ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
        : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
      await deleteCouponToCart(code, cart.id);
      await this.fetchCartData(true);
      this.setState({ loading: false });
    } catch (error) {
      console.log(error);
      this.setState({ loading: false });
    }
  }

  isCartEmpty() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    return (
      !this.state.loading &&
      (!cart || (!cart?.entries || cart?.entries?.length === 0))
    );
  }

  goToAllProductPage() {
    this.props.history.push({ pathname: commonConstant.pathLineOrdering, search: '?' });
  }

  goToAddressList = async () => {
    this.setState({ loading: true });
    if (this.urlParams.get(SESSION_KEY.isInstallment) === INSTALLMENT_TYPE.TRUE) {
      if (!sessionStorage.getItem(SESSION_KEY.zippCartId)) {
        CustomSweetAlert({
          title: "",
          text: message.error.cart,
          confirmButtonText: "ตกลง",
        });
      }
      return this.props.history.push({ pathname: commonConstant.pathPromotionAddressList, search: this.urlParams.toString() });
    }
    const liffProfile = await liffGetProfile();
    const getCustomerProfile = await getCustomerFOA(liffProfile.userId);
    let redirectPath =
      getCustomerProfile.type === 'public'
        ? commonConstant.pathFOARegister
        : commonConstant.pathPromotionAddressList;
    this.props.history.push({ pathname: redirectPath, search: this.urlParams.toString() }, { cart: this.state.cart });
  };

  getTotalPrice() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    if (!cart) {
      return <></>;
    }
    const totalPrice = cart?.subTotal?.filter(
      (value) => value.label === 'รวมค่าสินค้า',
    )[0];

    const price = getPriceFormat(totalPrice?.value?.price);
    return `฿ ${price}`;
  }

  getTotalDeliveryCost() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    if (!cart) {
      return <></>;
    }
    const totalDeliveryCost = cart?.subTotal?.filter(
      (value) => value.label === 'ค่าจัดส่ง',
    )[0];

    const price = getPriceFormat(totalDeliveryCost?.value?.price);
    return `฿ ${price}`;
  }

  getTotalDiscounts() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    if (!cart) {
      return <></>;
    }
    const totalOrderDiscounts = cart?.subTotal?.filter(
      (value) => value.label === 'ส่วนลดทั้งหมด',
    )[0];

    const price = getPriceFormat(totalOrderDiscounts?.value?.price);
    if (price == 0) {
      return `- ฿ ${price}`;
    } else {
      return `- ฿ ${price.substring(1)}`;
    }
  }

  getTotalAmwayPointForCartSummary(amwayValue) {
    if (!amwayValue) {
      return <></>;
    }

    const { businessVolume, pointValue } = amwayValue;
    if (businessVolume && pointValue) {
      return (
        <span>{`+ ${pointValue.toLocaleString()} / ${businessVolume.toLocaleString()}`}</span>
      );
    } else {
      return <></>;
    }
  }

  getTotalEntriesCount() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    let totalQty = 0;
    if (
      cart &&
      this.state.productEntries &&
      this.state.productEntries.length
    ) {
      this.state.productEntries.map((entry, index) => {
        totalQty += entry.quantity;
      });
    }

    return totalQty ? totalQty.toString() : '';
  }

  getTotalAmplusPointForCartSummary(memberPoints = '') {
    if (!memberPoints) {
      return <></>;
    }
    return <span> {memberPoints.toLocaleString()}</span>;
  }

  async gotoShopping() {
    let msgText = 'โปรโมชั่น';
    const liffProfile = await liffGetProfile();
    const getCustomerProfile = await getCustomerFOA(liffProfile.userId);
    if (
      getCustomerProfile.type === 'foa' ||
      getCustomerProfile.type === 'public'
    ) {
      msgText = 'สินค้าแนะนำ';
    }

    liff
      .sendMessages([
        {
          type: 'text',
          text: msgText,
        },
      ])
      .then(() => {
        console.log('message sent', msgText);
        liff.closeWindow();
      })
      .catch((err) => {
        console.log('error', err);
        liff.closeWindow();
      });
  }

  renderEmptyCart() {
    return (
      <>
        {this.renderCartSelectionTabBar()}
        <div className="empty-cart-div">
          <div className="empty-cart-container">
            <img
              className="empty-cart-img"
              src="/images/promotion/cart_not_found.png"
            />
            <div className="empty-cart-msg-div">
              <div className="empty-cart-label">ตะกร้าว่าง</div>
              <div className="empty-cart-productmsg">
                คุณยังไม่มีสินค้าในตะกร้า
              </div>
            </div>
            <button className="btn-shop-now" onClick={this.goToAllProductPage}>
              <img src="/images/sop/icon-add.svg" />
              ไปช็อปเลย
            </button>
          </div>
        </div>
      </>
    );
  }

  renderUserTypeIncentiveRow() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    const accountType = cart?.account?.accountType || '';

    if (isCartABOMemberType(accountType)) {
      if (isCartABOType(accountType)) {
        return (
          <div className="flex-between">
            <div className="cart-summary-label">PV / BV</div>
            <div className="cart-summary-value">
              {this.getTotalAmwayPointForCartSummary(cart?.amwayValue)}
            </div>
          </div>
        );
      } else {
        return <></>;
      }
    } else {
      return <></>;
    }
  }

  renderCartSummary() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    if (!cart) {
      return <></>;
    }

    return (
      <div className="cart-summary flex-between">
        <div className="flex-between">
          <div className="cart-summary-label">
            ยอดรวมสินค้า ({this.getTotalEntriesCount()})
          </div>
          <div className="cart-summary-price">{this.getTotalPrice()}</div>
        </div>
        <div className="flex-between">
          <div className="cart-summary-label">ค่าจัดส่ง</div>
          <div className="cart-summary-value">
            {this.getTotalDeliveryCost()}
          </div>
        </div>
        <div className="flex-between">
          <div className="cart-summary-label">ส่วนลด</div>
          <div className="cart-summary-value">{this.getTotalDiscounts()}</div>
        </div>
        {this.renderUserTypeIncentiveRow()}
      </div>
    );
  }

  renderCartFooter() {
    let cartTotalPrice = '฿ 0';
    let cartTotalAPoint = '0';
    let cartTotalPointValue = 'PV 0';
    let cartTotalBusinessValue = 'BV 0';
    let isABOAccount = false;
    let isMemberAccount = false;

    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;

    if (cart) {
      if (cart.totalPrice && cart.totalPrice.price) {
        cartTotalPrice = `฿ ${getPriceFormat(cart.totalPrice.price)}`;
      }
      cartTotalAPoint = cart.memberPoints
        ? `${cart.memberPoints.toLocaleString()}`
        : cartTotalAPoint;
      if (
        cart.amwayValue &&
        cart.amwayValue.businessVolume &&
        cart.amwayValue.pointValue
      ) {
        const { businessVolume, pointValue } = cart.amwayValue;
        cartTotalPointValue = `PV ${pointValue.toLocaleString()}`;
        cartTotalBusinessValue = `BV ${businessVolume.toLocaleString()}`;
      }
      if (cart?.account) {
        const { accountType = '' } = cart?.account ? cart?.account : {};
        isABOAccount = isCartABOType(accountType);
        isMemberAccount = isCartMemberType(accountType);
      }
    }

    return (
      <footer>
        <div className="cart-panel-footer">
          <div className="select-product-footer font-larger">
            {
              this.state.selected.length ?
                <div className="flex-between font-medium remove-promotion">
                  <Checkbox
                    containerClassname="remove-all"
                    checked={this.state.isSelectAll}
                    onClick={this.handleSelectAll}
                    svg={this.renderSvgForCheckbox()}
                  />
                  <div
                    className="remove-all-product"
                    style={{ margin: 'auto', paddingLeft: 4 }}
                  >
                    เลือกทั้งหมด
                  </div>
                </div>
                :
                <div className="price-pvbv-container">
                  <div className="product-panel-footer-price">
                    <span>{cartTotalPrice}</span>
                  </div>
                  {isABOAccount && (
                    <div className="pvbv-total">
                      <span>{`${cartTotalPointValue} / ${cartTotalBusinessValue}`}</span>
                    </div>
                  )}
                </div>
            }
            {
              this.state.selected.length ?
                <button className="btn-remove"
                  onClick={this.onDelete}
                >{`ลบ (${this.state.selected.length})`}</button>
                :
                cartTotalPrice === '฿ 0' ? (
                  <span className="add-to-cart-disabled" disabled>
                    <span className="add-to-cart-text-disabled">สั่งซื้อ</span>
                  </span>
                ) : (
                  <span
                    className="add-to-cart-active"
                    onClick={this.goToAddressList}
                  >
                    <span className="add-to-cart-text-enabled">สั่งซื้อ</span>
                  </span>
                )}
          </div>
        </div>
      </footer>
    );
  }

  renderSopPromotionSelectionSection() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    const { accountType = '' } = cart && cart.account ? cart.account : {};
    const isABOMemberType = isCartABOMemberType(accountType);

    if (
      isABOMemberType &&
      this.state.selectedPaymentTab &&
      this.state.selectedPaymentTab === PAYMENT_OPTION.PIF
    ) {
      return (
        <div>
          <div className="sop-btn" onClick={() => this.onSopBtnClick()}>
            + เพิ่มสินค้า SOP
          </div>
          <div className="prm-btn" onClick={() => this.onPromotionBtnClick()}>
            + เพิ่มสินค้าโปรโมชัน
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  }

  renderSelectedPaymentCart(paymentType) {
    console.log('Selected Payment Tab : ' + paymentType);
    if (paymentType) {
      this.setState({ lastSelectedPaymentTab: paymentType });
      this.updateSelectedPaymentTab(paymentType);
    }
  }

  updateSelectedPaymentTab(paymentType) {
    if (paymentType === PAYMENT_OPTION.ZIPP) {
      this.setState({
        cart: this.state.zippCart,
        isInstallment: true,
        cartTypeName: 'zippCart',
        selectedPaymentTab: PAYMENT_OPTION.ZIPP,
        productEntries: this.state.zippProductEntries,
      });
    } else if (paymentType === PAYMENT_OPTION.PIF) {
      this.setState({
        cart: this.state.pifCart,
        isInstallment: false,
        cartTypeName: 'pifCart',
        selectedPaymentTab: PAYMENT_OPTION.PIF,
        productEntries: this.state.pifProductEntries,
      });
    }
  }

  renderCartSelectionTabBar() {
    let isABOMemberType = false;
    let pifCartEntriesLength = 0;
    let zippCartEntriesLength = 0;
    let customer = JSON.parse(sessionStorage.getItem('customer'));
    isABOMemberType = isCartABOMemberType(customer.type);
    pifCartEntriesLength = this.state.pifProductEntries.length
      ? this.state.pifProductEntries.length
      : 0;
    zippCartEntriesLength = this.state.zippProductEntries.length
      ? this.state.zippProductEntries.length
      : 0;

    if (isABOMemberType) {
      return (
        <div className="cartTabBar">
          <div
            className="cartPaymentSelectionTab"
            onClick={() => this.renderSelectedPaymentCart(PAYMENT_OPTION.PIF)}
          >
            <div
              className="cartPaymentSelectionText"
              style={
                this.state.selectedPaymentTab === PAYMENT_OPTION.PIF
                  ? { color: '#38539A' }
                  : { color: '#2C2C2C' }
              }
            >
              {`ชำระเต็มจำนวน${pifCartEntriesLength > 0 ? ` (${pifCartEntriesLength})` : ''}`}
            </div>
            <div
              className="selectedCartTabBar"
              style={
                this.state.selectedPaymentTab === PAYMENT_OPTION.ZIPP
                  ? { visibility: 'hidden' }
                  : {}
              }
            ></div>
          </div>
          <div
            className="cartPaymentSelectionTab"
            onClick={() => this.renderSelectedPaymentCart(PAYMENT_OPTION.ZIPP)}
          >
            <div
              className="cartPaymentSelectionText"
              style={
                this.state.selectedPaymentTab === PAYMENT_OPTION.ZIPP
                  ? { color: '#38539A' }
                  : { color: '#2C2C2C' }
              }
            >
              {`ผ่อนชำระ${zippCartEntriesLength > 0 ? ` (${zippCartEntriesLength})` : ''}`}
            </div>
            <div
              className="selectedCartTabBar"
              style={
                this.state.selectedPaymentTab === PAYMENT_OPTION.PIF
                  ? { visibility: 'hidden' }
                  : {}
              }
            ></div>
          </div>
        </div>
      );
    } else if (!pifCartEntriesLength || !zippCartEntriesLength) {
      return <></>;
    } else {
      return (
        <div className="customer-pay-select-div">
          <div className="pay-div">
            <div className="pif-text">ตะกร้า ({pifCartEntriesLength})</div>
          </div>
        </div>
      );
    }
  }

  renderPromotionList() {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    if (cart && this.state.promotionList && this.state.promotionList.length) {
      return this.state.promotionList.map((promotion, index) => {
        const imgUrl = promotion.cardImageUrl ? promotion.cardImageUrl : '';
        const prmName = promotion.name ? promotion.name : '';
        return (
          <div className="card-prm-body" key={index}>
            <div className="flex">
              <div className="product-image-container-cart">
                <div className="card-product-img-promotion mb-10">
                  <img src={imgUrl} alt="product image" />
                </div>
              </div>
              <div>
                <div className="card-product-title mb-10">
                  <div className="font-black card-product-title-text">
                    {prmName}
                  </div>
                </div>
              </div>
            </div>
            <div className="price-selection-panel flex">
              <div>
                <div className="font-black footer-price-bold"></div>
                <div>
                  {this.props.amwayValue && (
                    <div className="amway-value-dark"></div>
                  )}
                </div>
              </div>

              <div className="select-prmlist-btn font-larger">
                <div className="text-center">
                  <button
                    className={`away-button active`}
                    onClick={() => this.navigatePromotion(promotion)}
                  >
                    เลือก
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      });
    } else {
      return <></>;
    }
  }

  renderCart() {
    let chkCustomer = JSON.parse(sessionStorage.getItem('customer'));
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    if (chkCustomer) {
      if (chkCustomer.notCommerce == '1') {
        localStorage.setItem('deleteIds', '[]');
        liff.closeWindow();
        return <section>{this.renderEmptyCart()}</section>;
      }
    }

    if (this.isCartEmpty()) {
      localStorage.setItem('deleteIds', '[]');
      return <section>{this.renderEmptyCart()}</section>;
    }

    return !this.state.loading && (
      <div>
        {this.renderCartSelectionTabBar()}
        <div
          className="cart-wrapper scroll-auto cart-panel-container"
          style={{ height: 'calc((100vh - 52px) - 88px)' }}
        >
          <div className="pd-15">
            <div className="flex-between font-small pb-10">
              <span className="product-list-label">รายการสินค้า</span>
              <div className="link-text font-stock">
                <img src='/images/promotion/icon_plus_red.svg' className='plus-icon-text' />
                <span
                  className="underline"
                  onClick={this.goToAllProductPage}
                >
                  {ROUTE_TO_PRODUCT_PAGE}
                </span>
              </div>
            </div>
            {this.renderProduct()}
            {this.renderPromotionProduct()}
            {this.renderGiftProduct()}
          </div>
          {!this.state.customerFOA && (
            <div className="cart-coupon-container">
              <div className="pd-16">
                <div className="flex-between mb-16">
                  <div className="coupon-label">
                    <img
                      style={{ width: 15, marginRight: 15 }}
                      src="/images/promotion/icon_Discount.png"
                    />
                    สิทธิ์ส่วนลด และโปรโมชันโค้ด
                  </div>
                  <div onClick={this.getPromotions} className="flex">
                    <div className="coupon-link">{`เลือกคูปอง`}</div>
                    <span className="link-text-icon">{'>'}</span>
                  </div>
                </div>
                <InputCoupon
                  callback={this.fetchCartData}
                  cartId={cart ? cart?.id : null}
                />
                {this.displayFooterCoupon()}
              </div>
            </div>
          )}
          <Liff
            title={'เลือกคูปอง'}
            onClose={this.onCloseLiff}
            isOpen={this.state.isLiffopen}
          >
            <CouponPanel
              cartId={cart ? cart?.id : null}
              cartData={cart ? cart : {}}
              isOpen={this.state.isLiffopen}
              onClose={this.onCloseLiff}
            />
          </Liff>
          <LiffPromotionList
            title={'เพิ่มสินค้าโปรโมชัน'}
            onClose={this.onClosePromotionLiff}
            isOpen={this.state.isLiffPromotionOpen}
            bgColor={'#f4f4f4'}
          >
            <div
              className="content scroll-auto"
              style={{ height: 'calc(85vh - 50px)' }}
            >
              {this.renderPromotionList()}
            </div>
          </LiffPromotionList>
          {this.renderCartSummary()}
        </div>
        {this.renderCartFooter()}
      </div>
    );
  }

  async onDelete(idList = null, from = 'btn',) {
    const cart = this.state.isInstallment
      ? sessionStorage.getItem(SESSION_KEY.zippCartId) ? this.state.zippCart?.[0] : null
      : sessionStorage.getItem(SESSION_KEY.pifCartId) ? this.state.pifCart?.[0] : null;
    let { selected } = this.state;
    if (from !== 'btn') {
      selected = Array.isArray(idList) ? idList : [idList];
    }
    const filterSOP = cart.entries.filter((entry) => {
      return entry['hasSopEntries'] && !entry['kitEntryCode'];
    });
    for (const [index, item] of filterSOP.entries()) {
      const hasSelected = this.state.selected.includes(item.id);
      if (!hasSelected) continue;
      filterSOP[index]['isDeleted'] = true;
    }
    try {
      const { userId } = await liffGetProfile();

      if (selected.length === 0) {
        return CustomSweetAlert({
          title: "",
          text: DELETE_PRODUCT_ERROR_MSG,
          confirmButtonText: "ตกลง",
        });
      }

      this.setState({ loading: true });
      const isInstallment = this.urlParams.get(SESSION_KEY.isInstallment) === INSTALLMENT_TYPE.TRUE;
      const customerFOA = JSON.parse(sessionStorage.getItem('customerFOAData'));
      const guid = sessionStorage.getItem('guid');
      const sortSelected = selected.sort((a, b) => a - b).reverse();
      const selectedFilterSOP = filterSOP.filter(
        (sop) => selected.includes(sop.id)
      );
      !customerFOA
        ? await deleteCartItems(
          cart.id,
          sortSelected,
          isInstallment,
          userId,
          selectedFilterSOP,
        )
        : await deleteCartItemsPublic(
          cart.id,
          sortSelected,
          isInstallment,
          userId,
          selectedFilterSOP,
          guid,
        );
      await this.props.getCartData("FULL", getCartId(this.urlParams.get(SESSION_KEY.isInstallment)));
      this.setState({ [this.state.cartTypeName]: this.props?.data, loading: false, selected: [], isSelectAll: false });
      this.handleIntitCart();
    } catch (error) {
      console.log(error);
      CustomSweetAlert({
        title: "",
        text: message.error.somethingWrong,
        confirmButtonText: "ตกลง",
      });
      this.setState({ loading: false });
    }
  }

  handleSelectAll() {
    const { isSelectAll, productEntries } = this.state;

    const allIds = productEntries.flatMap(entry =>
      Array.isArray(entry?.entriesId) && entry?.entriesId?.length
        ? entry.entriesId
        : [entry.id]
    );

    const uniqueIds = Array.from(new Set(allIds));

    if (isSelectAll) {
      this.setState({ isSelectAll: false, selected: [] });
    } else {
      this.setState({ isSelectAll: true, selected: uniqueIds });
    }
  }

  handleCheckBoxClick(idList) {
    const { selected, productEntries } = this.state;

    const isAlreadySelected = idList.every(id => selected.includes(id));

    let newSelected = [...selected];

    if (isAlreadySelected) {
      newSelected = newSelected.filter(id => !idList.includes(id));
    } else {
      newSelected = Array.from(new Set([...newSelected, ...idList]));
    }

    const allIds = productEntries.flatMap(entry =>
      Array.isArray(entry?.entriesId) && entry?.entriesId?.length
        ? entry?.entriesId
        : [entry?.id]
    );

    const isSelectAll = allIds.every(id => newSelected.includes(id));

    this.setState({ selected: newSelected, isSelectAll });
  }

  renderSvgForCheckbox() {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ top: '0px', left: '0px' }}
      >
        <g id="icon-check">
          <path
            id="Icon-check (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4793 3.53588C14.7356 3.80021 14.7291 4.22227 14.4647 4.47858L6.21475 12.4786C5.95616 12.7293 5.54515 12.7293 5.28655 12.4786L1.53655 8.84222C1.27223 8.5859 1.26574 8.16384 1.52205 7.89952C1.77837 7.6352 2.20043 7.6287 2.46475 7.88502L5.75065 11.0713L13.5366 3.52138C13.8009 3.26507 14.2229 3.27156 14.4793 3.53588Z"
            fill="#FAFAFA"
          />
        </g>
      </svg>
    );
  }

  render() {
    return (
      <section>
        <LoadingOverlay
          text="Loading"
          spinner
          active={this.state.loading}
          styles={{ wrapper: { width: '100%', minHeight: '100%' } }}
        />
        {this.renderCart()}
        {this.state.isSopLiffOpen && (
          <Liff
            title={'เพิ่มสินค้า SOP'}
            onClose={() => this.onCloseSopLiff()}
            isOpen={this.state.isSopLiffOpen}
          >
            <div className="cart-profile-list">
              <SOPProfileList notFromCartPage={false} />
            </div>
          </Liff>
        )}
      </section>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    data: state.cartApi.data,
    loading: state.cartApi.loading,
    error: state.cartApi.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCartData: (fields, cartId) => dispatch(getCartData(fields, cartId)),
    updateCart: cart => dispatch({ type: CART_UPDATE, payload: cart })
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CartPromotion);
